<template>
  <div>
    <transition name="ani-slide-in">
      <component v-if="!$auth.loading && !$workSessions.lmraLocked" :is="currentActiveComponent" @closeCurrentComponent="checkActiveComponent"
                 :enableTAGCodeScanner="CAPSEnableTagCodeScanner" :TAGCodeMandatory="TAGMandatory" @forceLoadDefaultLMRA="forceLoadDefaultLmra">
      </component>
    </transition>
    <div v-if="$workSessions.lmraLocked">
      <v-container>
        <v-row>
          <v-col cols="12">
            <p class="justify-center" v-html="$sanitize(
                $vuetify.lang.t('$vuetify.workSessions.lmraLocked.lmraComponentLockedInfo'), {
                allowedTags: ['b','br','i']
                })">
            </p>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-dialog
        v-model="isLoading"
        persistent
        width="300"
    >
      <v-card
          color="primary"
          dark
      >
        <v-card-text class="text-center">
          <p class="pt-2 text-uppercase">{{ $vuetify.lang.t('$vuetify.lmraComponent.loadingProjectData') }}</p>
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LmraStartStopComponent from "../components/modules/lmra/LmraStartStopComponent";
import ClientProjectSettings from "../components/modules/settings/ClientProjectSettings";
import DefaultLmraComponent from "../components/modules/lmra/DefaultLmraComponent";
import WorkReportComponent from "../components/modules/lmra/WorkReportComponent";
import StaticThreeStateLmra from "../components/modules/lmra/StaticThreeStateLmra";

import {/*startedNormal, startedStaticThreeState,  startedLoto,*/ stopWorkEvent, startWorkEvent,} from "../store"; //
import CapSaveStateInvalidatorMixin from "../mixins/capSettings/CapSaveStateInvalidatorMixin";
import appSettings from "@/mixins/config/appSettings";
import resourcesApi from "@/api/resources/resourcesApi";
import store from "@/store";
import { CustomLmraListsHelper } from "@/helpers/customLmraLists/CustomLmraListsHelper";
import authMixin from "@/auth/sanctum/mixins/authMixin";
import {DynamicQuestionListHelper} from "@/helpers/DynamicQuestionListHelper";
import workSessionMixin from "@/workSessions/mixins/workSessionMixin";

const defaultLMRAComponent = 'defaultLmra';
const workReportComponent = 'workReport';
const startStopComponent = 'startStop'

export default {
  name: "Lmra",
  data: () => {
    return {
      lmraStartType: null,
      TAGMandatory: false,
      CAPSEnableTagCodeScanner: false,
      isLoading: false,
      currentActiveComponent: null,
      loadCustomLmraDataFailed: false,
      loadCustomLmraError: null,
    }
  },
  components: {
    startStop: LmraStartStopComponent,
    cPSettings: ClientProjectSettings,
    defaultLmra: DefaultLmraComponent,
    s3sLmra: StaticThreeStateLmra,
    workReport: WorkReportComponent
  },
  mixins: [CapSaveStateInvalidatorMixin, appSettings, authMixin, workSessionMixin],
  methods: {
    async checkActiveComponent() {
      if(this.hasForceCloseWorkSessionFlag){
        activeComponent = workReportComponent;
      }else{
        //START STOP SHOULD BE DEFAULT SCREEN...
        var activeComponent = startStopComponent;

        //window.console.log('ACTIVATED...');
        let startStopEvent = await this.$store.state.userStartStopEvent;
        if (startStopEvent === startWorkEvent) {
          ///window.console.log('SWEVENT...');
          let validated = await this.$store.state.capsSaveValidated;
          if (validated === true) {
            let lmraView = await this.loadLMRAComponent();
            //window.console.log(lmraView);
            activeComponent = lmraView;
          } else {
            this.setCAPSUseTAGCodeScanner();
            activeComponent = 'cPSettings';
          }

        }

        if (startStopEvent === stopWorkEvent) {
          //window.console.log('STOPEVENT...');
          activeComponent = workReportComponent;
        }
      }


      this.currentActiveComponent = activeComponent
    },
    async getCurrentProjectCustomLmraListKey() {
      return (
          typeof this.$store.state.currentClientProjectSettings.project === 'object' &&
          this.$store.state.currentClientProjectSettings.project.linked_custom_lmra_list_key !== undefined
      ) ? this.$store.state.currentClientProjectSettings.project.linked_custom_lmra_list_key : null;
    },
    async loadLMRAComponent() {
      this.isLoading = true;
      let componentToLoad = '';
      let customLmraResponse = await this.checkForCustomLmraData();
      //AWAIT DYNAMIC QUESTIONS RESPONSE BEFORE GOING FORWARD... DEFAULT LMRA ALSO DEPENDS ON IT
      let dynamicQuestionListResponse = await DynamicQuestionListHelper.getDynamicQuestions();

      //CHECK DYNAMIC QUESTIONS RESPONSE
      if (dynamicQuestionListResponse !== undefined && dynamicQuestionListResponse.data !== undefined && dynamicQuestionListResponse.data !== null) {
        await DynamicQuestionListHelper.storeCurrentDynamicQuestionListInMemory(dynamicQuestionListResponse.data);
      }


      /* IF NOTHING THERE IS AN ERROR CONTACTING THE SERVER etc... return default */
      if (this.loadCustomLmraDataFailed) {
        var message = null;
        if (this.loadCustomLmraError.response.data !== undefined &&
            this.loadCustomLmraError.response.data !== null &&
            this.loadCustomLmraError.response.data.status !== undefined) {
            message = this.loadCustomLmraError.response.data.status;
        }
        this.showNetworkErrorSnackBar(message);
        this.isLoading = false;
        return defaultLMRAComponent;
      }

      //SHOULD HAVE DATA CHECK IT...
      if (customLmraResponse.data !== undefined && customLmraResponse.data !== null && customLmraResponse.data.type !== null && customLmraResponse.data.type !== undefined) {
        let customList = customLmraResponse.data;
        switch (customList.type) {
          case 'THREE-STATE':
            if(CustomLmraListsHelper.isValidThreeStateQuestionListObject(customList)){
              await CustomLmraListsHelper.setValidatedCustomLmraList(customList);
              componentToLoad = 's3sLmra';
            }else{
              //window.console.log('LOADING DEFAULT');
              componentToLoad =  defaultLMRAComponent;
            }
            break;
          default:
            //window.console.log('JUST LOAD component');
            componentToLoad =   defaultLMRAComponent;
        }

      } else {
        //SOMETHING WENT WRONG THO
        componentToLoad =  defaultLMRAComponent;
      }
      //remove loading block
      this.isLoading = false;
      return componentToLoad;
    },
    async resetStartStopEventAndType() {
      await this.$store.commit('setUserStartEventType', false);
      await this.$store.commit('setUserStartStopEvent', false);
    },
    setCAPSUseTAGCodeScanner() {
      if (this.appSettings.usesCAPTagCodeScanner) {
        this.CAPSEnableTagCodeScanner = true;
      }
    },
    async showNetworkErrorSnackBar($status) {
      {
        /*window.console.log('launching snackbar message');
        window.console.log($status);*/
        var $error = this.$vuetify.lang.t('$vuetify.lmraComponent.errors.unknownError');
        switch ($status) {
          case 'no-list-data-found':
            $error = this.$vuetify.lang.t('$vuetify.lmraComponent.errors.noListDataFound');
            break;
          case 'no-default-list-found':
            $error = this.$vuetify.lang.t('$vuetify.lmraComponent.errors.noDefaultListFound');
            break;
        }
        await store.commit('launchSnackbarMessage', $error);
      }
    },
    async checkForCustomLmraData() {
      let $listKey = await this.getCurrentProjectCustomLmraListKey();
      this.loadCustomLmraDataFailed = false;
      this.loadCustomLmraError = null;
      var dataResponse = await resourcesApi.getCustomLmraList($listKey)
          .then(response => {
            return response;
          }).catch((error) => {
            this.loadCustomLmraDataFailed = true;
            this.loadCustomLmraError = error;
          });

      return dataResponse;
    },
    forceLoadDefaultLmra(){
      this.currentActiveComponent = defaultLMRAComponent;
    }
  },
  async mounted() {
    if(!this.$workSessions.loading && !this.hasForceCloseWorkSessionFlag){
      await this.$workSessions.performSessionCheck();
    }
    await this.resetStartStopEventAndType();
    await this.checkActiveComponent();
  },
  created() {
    //DISPATCH LOCATION GRAB
    this.$store.dispatch('getUserLocation');
  },
  destroyed() {
    //window.console.log('destroyed');
    this.resetStartStopEventAndType();
  },
  watch :{
    hasForceCloseWorkSessionFlag(newValue){
      window.console.log('Change detected in here !!!')
      window.console.log(newValue);
      if(newValue){
        window.console.log('SHOULD CHANGE COMPONENT!');
        this.currentActiveComponent = workReportComponent;
      }
    }
  }
}
</script>

<style scoped>

</style>